import _ from 'lodash';

import {
  ImportInventoryLocationInput,
  useImportNetSuiteInventoryLocationsMutation
} from 'generated/graphql';
import {
  useCallback,
  useMemo
} from 'react';



export function useImportNetSuiteInventoryLocations() {
  const [fnMutate, tuple] = useImportNetSuiteInventoryLocationsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = useCallback(
    (rows: Array<_.Dictionary<string>>) => {
      const input = rows.map((row): ImportInventoryLocationInput => ({
        netSuiteInternalId: row['Internal ID'],
        name: row['Name']
      }));

      fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
